import axios from "axios";
import {APP_DISPLAY_ADS_API_ENDPOINT} from "../../../../../constants/api_urls";
import {getUserToken} from "../../../../../utils/functions/userToken";

export const validateCampaignName = async (accountId = null, hotelId = null, campaignName, campaignId = null) => {
    const jwtToken = getUserToken();
    let apiEndpoint;

    if (accountId && hotelId) {
        apiEndpoint = `${APP_DISPLAY_ADS_API_ENDPOINT}/api/display-ads/campaign-validator/campaign-settings/validate-campaign-name/${accountId}/${hotelId}/`;
    } else if (campaignId) {
        apiEndpoint = `${APP_DISPLAY_ADS_API_ENDPOINT}/api/display-ads/campaign-validator/campaign-settings/validate-edit-campaign-name/${campaignId}/`;
    } else {
        return { success: false, error: "Missing required parameters for validation" };
    }

    try {
        const response = await axios.post(
            apiEndpoint,
            {
                campaign_name: campaignName
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateLanguage = async (languageId) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_DISPLAY_ADS_API_ENDPOINT}/api/display-ads/campaign-validator/campaign-settings/validate-lang/`,
            [languageId],
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );

        const data = response.data;
        if (Array.isArray(data) && data.length === 0) {
            return { success: true };
        }
    } catch (error) {
        const errorMessage = error?.[0]?.errorMessage || "Internal Server Error, please retry later";
        return { success: false, error: errorMessage };
    }
};


export const validateDisplayAdsCampaignSettings = async (campaignSettings, idAccount, idHotel) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_DISPLAY_ADS_API_ENDPOINT}/api/display-ads/campaign-validator/campaign-settings/validate-add-campaign-settings/${idAccount}/${idHotel}/`,
            campaignSettings,
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );

        const { data } = response;
        const errors = {};

        if (data.campaign_name?.errorMessage) {
            errors.campaignName = data.campaign_name.errorMessage;
        }

        if (data.campaign_lang?.[0]?.errorMessage) {
            errors.campaignLang = data.campaign_lang[0].errorMessage;
        }

        if (Object.keys(errors).length > 0) {
            return { success: false, errors };
        }

        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, errors: { global: "An unexpected error occurred during validation." } };
    }
};

